<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">商品评论管理</li>
            </ol>
        </div>
        <div class="content-operator content-border">
        </div>
<!--        <div class="content-query content-border">-->
<!--            <el-form :inline="true" :model="query" class="demo-form-inline">-->
<!--                <el-form-item>-->
<!--                    <el-button type="primary" @click="submitQuery(1)" size="small">搜索</el-button>-->
<!--                </el-form-item>-->
<!--            </el-form>-->
<!--        </div>-->
<!--        <hr/>-->
        <div class="title">
            <span>商品列表</span>
        </div>
        <div class="content-data" v-if="comments && 0 < comments.length">
            <el-table highlight-current-row :data="comments" border>
                <el-table-column align="center" type="index"/>
                <el-table-column align="center" label="商品信息">
                    <template slot-scope="scope">
                        <user-info :icon-path="dynamicPath+scope.row.iconPath" :nickname="scope.row.goodsName"/>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="评论用户">
                    <template slot-scope="scope">
                        <user-info :icon-path="scope.row.userIconPath" :nickname="scope.row.userNickname"/>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="评论" prop="remark"/>
                <el-table-column align="center" label="评分" prop="score"/>
                <el-table-column align="center" label="回复">
                    <template slot-scope="scope">
                        {{ scope.row.reply || '未回复' }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="评论图片">
                    <template slot-scope="scope">
            <span v-if="scope.row.attaches&&scope.row.attaches.length>0">
               <p>
              <el-image
                      style="width: 100px; height: 100px"
                      :src="scope.row.attaches[0]"
                      :preview-src-list="scope.row.attaches">
              </el-image>
            </p>
            <p>
              {{ scope.row.attaches.length }}张
            </p>
            </span>
                        <span v-else>未评论图片</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="评论时间" prop="createTime"/>
                <el-table-column align="center" fixed="right" label="操作" width="250px">
                    <template slot-scope="scope">
                        <el-tooltip content="回复/修改回复" placement="top"
                                    effect="light">
                            <el-button type="primary" size="mini" round @click="openComment(scope.row)">
                                <svg-icon icon-class="comment"/>
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <el-dialog title="回复/修改回复" :visible.sync="visible" width="35%" center>
            <el-form size="mini" ref="formName" label-width="110px"
                     style="margin:0 auto;">
                <el-form-item label="评论:" prop="goodsPriceId">
                    <el-input type="textarea" disabled v-model="saveCommentModel.remark"></el-input>
                </el-form-item>
                <el-form-item label="回复:" prop="goodsPriceId">
                    <el-input type="textarea" v-model="saveCommentModel.reply"
                              :autosize="{ minRows: 15, maxRows: 15}"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" @click="saveReply()">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <vue-pager v-bind:datafile="fillData" url="goodsComment/pageGoodsComment" v-bind:query="query" ref="pager"
                   v-bind:init="true"></vue-pager>
    </div>
</template>
<script>


    export default {
        data() {
            return {
                visible: false,
                query: {},
                comments: [],
                dynamicPath: config.dynamicResourcePath,
                saveCommentModel: {
                    reply: '',
                    remark: ''
                }
            }
        },
        created() {

        },
        methods: {
            openComment(row) {
                let {remark, id, reply} = row
                this.saveCommentModel.reply = reply
                this.saveCommentModel.remark = remark
                this.saveCommentModel.goodsCommentId = id
                this.visible = true
            },
            fillData(response) {
                let _this = this
                let temps = response.items || []
                temps.forEach((item) => {
                    let paths = []
                    if (item.attaches) {
                        item.attaches.forEach((path) => {
                            paths.push(_this.dynamicPath + path.path)
                        })
                        item.attaches = paths
                    }
                })
                this.comments = temps;
            },
            submitQuery(_num) {
                var _this = this;
                _this.comments = [];
                _this.$refs.pager.gotoPage(_num);
            },
            saveReply() {
                var _this = this;
                _this.$confirm('是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.$common.my_ajax({
                        url: '/goodsComment/saveGoodsCommentReply',
                        data: _this.saveCommentModel,
                        success: function (response) {
                            _this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function () {
                                    _this.visible = false
                                    _this.submitQuery(1)
                                }
                            });
                        }
                    });
                }).catch((e) => {
                    console.log(e);
                });
            },

        },
    }
</script>
<style scoped>
    .el-dropdown {
        margin: 10px;
    }
</style>
